import React, { useEffect, useState, useMemo } from 'react';
import instanciaAxios, { esErrorPermiso } from '../../miscelaneo/instanciaAxios';
import { toast } from 'react-toastify';
import LoadingSpinner from '../util/SpinnerCargando';
import { FaSearch } from "react-icons/fa";
import PlantillaModal from '../util/PlantillaModal';
import ModalSeleccionCuenta from '../util/ModalSeleccionCuenta';
import InputBusquedaRNC from '../util/Inputs/InputBusquedaRNC';
import { PAISES, TIPOS_DIRECCION, MUNICIPIOS, PROVINCIAS, obtenerProvinciasPorPais, obtenerMunicipiosPorProvincia } from '../../miscelaneo/datosGeograficos';
import TablaEntidad from '../util/tablas/TablaEntidad';
import FuncionesMantenimientoEntidad from './FuncionesMantenimientoEntidad';
import FuncionesGenerales from '../util/FuncionesGenerales';
import { visible } from '../../miscelaneo/Caracteristica';
import DockVerticalDerecha from '../estructura/DockVerticalDerecha';
import { FiPlus, FiEdit, FiSave, FiSearch } from 'react-icons/fi';
import { 
  esEmailValido, 
  esRNCValido, 
  esCedulaValida, 
  esTelefonoValido, 
  esPasaporteValido,
  esPorcentajeValido,
  noEsFechaFutura,
  esFechaPosterior,
  esNumeroNoNegativo
} from '../util/ValidacionesCampos';

const { ObtenerEntidadDetallada, ObtenerPayload, generarCamposFormulario, limpiarCampos } = FuncionesMantenimientoEntidad();
const {formatearFechaInput} = FuncionesGenerales();
const MantenimientoEntidad = () => {
  // const [sexos, setSexos] = useState([]);
  // const [paises, setPaises] = useState([]);
  const [cargando, setCargando] = useState(true); // 1. Estado de carga
  // Deshabilita el botón "Guardar" mientras se espera la respuesta del backend
  // (evita que un doble clic duplique la entidad).
  const [guardandoEntidad, setGuardandoEntidad] = useState(false);
  const [modo, setModo] = useState('creacion');
  const [camposFormulario, setCamposFormulario] = useState([]);
  const [formData, setFormData] = useState({});
  const [mostrarModalCuenta, setMostrarModalCuenta] = useState(false);
  const [cuentaSeleccionada, setCuentaSeleccionada] = useState(null);
  const [campoCuentaActivo, setCampoCuentaActivo] = useState(null); // ej. "cuenta_debito" o "cuenta_credito"
  const [nombresCuentas, setNombresCuentas] = useState({});
  const [sexos, setSexos] = useState([]);
  const [tipos_comprobantes_fiscales, setTiposComprobantesFiscales] = useState([]);
  const [listas_precio, setListasPrecio] = useState([]);
  const [puestos,setPuestos] = useState([]);
  const [sucursales,setSucursales] = useState([]);
  const [bancos,setBancos] = useState([]);
  const [tipos_cuenta_banco,setTiposCuentaBanco] = useState([]);
  const [mostarModalCliente,setMostrarModalCliente] = useState(false);
  const [entidadSeleccionada,setEntidadSeleccionada] = useState({});
  const [editable,setEditable] = useState({});
  const [validacionRNC, setValidacionRNC] = useState({ valido: true, mensaje: '' });
  const [validacionCedula, setValidacionCedula] = useState({ valido: true, mensaje: '' });

  // Filtrado local de datos geográficos (reemplaza llamadas API cascada)
  const provincias = useMemo(() =>
    formData.direccion_id_pais ? obtenerProvinciasPorPais(formData.direccion_id_pais) : [],
    [formData.direccion_id_pais]
  );
  const municipios = useMemo(() =>
    formData.direccion_id_provincia ? obtenerMunicipiosPorProvincia(formData.direccion_id_provincia) : [],
    [formData.direccion_id_provincia]
  );

  useEffect(() => {
    setEditable(modo !== 'ver');
    if(modo ==='ver'){
      setEntidadSeleccionada(null);
      toast.info('Modo solo observación');
     }
    if(modo ==='edicion'){
      setEntidadSeleccionada(null);
      toast.info('Modo edición');
     }
    if(modo ==='creacion'){
     setEntidadSeleccionada(null);
     limpiarCampos(camposFormulario,setFormData,setTabsActivos,setNombresCuentas);
     toast.info('Modo creación');
    }
  }, [modo]);
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [sexos, tipos_comprobantes_fiscales, listas_precio, bancos, tipos_cuenta_banco] = await Promise.all([
          instanciaAxios.get('/miscelaneo/sexo'),
          instanciaAxios.get('/comprobantefiscal/tipo'),
          instanciaAxios.get('/miscelaneo/lista_precio'),
          instanciaAxios.get('/banco'),
          instanciaAxios.get('/banco/tipocuentabanco'),
        ]);
        setSexos(sexos.data);
        setTiposComprobantesFiscales(tipos_comprobantes_fiscales.data);
        setListasPrecio(listas_precio.data);
        setBancos(bancos.data);
        setTiposCuentaBanco(tipos_cuenta_banco.data);
        const campos = generarCamposFormulario(sexos.data, PAISES, tipos_comprobantes_fiscales.data, listas_precio.data, nombresCuentas, [], [], TIPOS_DIRECCION, bancos.data, tipos_cuenta_banco.data, [], []);
        setCamposFormulario(campos);
      } catch (error) {
        if (esErrorPermiso(error)) return;
        console.error('Error fetching data:', error);
        toast.error('Error al cargar datos iniciales');
      } finally {
        setCargando(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    setCamposFormulario(generarCamposFormulario(sexos, PAISES, tipos_comprobantes_fiscales, listas_precio, nombresCuentas, puestos, sucursales, TIPOS_DIRECCION, bancos, tipos_cuenta_banco, provincias, municipios));
  }, [nombresCuentas, sexos, tipos_comprobantes_fiscales, listas_precio, bancos, tipos_cuenta_banco, provincias, municipios]);

  useEffect(() => {
  if (Object.keys(formData).length === 0) {
    const initialData = {};
    camposFormulario.forEach(campo => {
      initialData[campo.id] = '';
    });
    initialData.tipos_entidad = [];
    setFormData(initialData);
  }
}, [camposFormulario]);


  async function handleSeleccionarEntidad(entidad) {
    try {
      setEntidadSeleccionada(entidad.id_entidad);
      const entidadDetallada = await ObtenerEntidadDetallada(entidad.id_entidad)
      limpiarCampos(camposFormulario, setFormData, setTabsActivos,setNombresCuentas)
      setFormData((prevFormData) => ({
        ...prevFormData,
        id_entidad: entidad.id_entidad,
      }));
      setTabSeleccionado('general')
      const detallesGenerales = entidadDetallada.detallesGenerales;
      const detallesCliente = entidadDetallada.detallesCliente;
      const detallesProveedor = entidadDetallada.detallesProveedor;
      const detallesEmpleado = entidadDetallada.detallesEmpleado;
      const detallesSueldo = entidadDetallada.detallesSueldo;

  
      if (detallesCliente) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          tipos_entidad: [...prevFormData.tipos_entidad, 1],
        }));
      
        setTabsActivos((prevTabsActivos) => ({
          ...prevTabsActivos,
          cliente:true
        }));
      }
      if (detallesProveedor) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          tipos_entidad: [...prevFormData.tipos_entidad, 2],
        }));
      
        setTabsActivos((prevTabsActivos) => ({
          ...prevTabsActivos,
          proveedor:true
        }));
      }
      if (detallesEmpleado) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          tipos_entidad: [...prevFormData.tipos_entidad, 3],
        }));
      
        setTabsActivos((prevTabsActivos) => ({
          ...prevTabsActivos,
          empleado:true
        }));
      }
      const cuentas_banco = detallesGenerales.cuentas_banco || [];

      // Derivar provincia y país a partir del municipio almacenado
      let direccion_id_provincia = '';
      let direccion_id_pais = '';
      if (detallesGenerales.direccion_id_municipio) {
        const mun = MUNICIPIOS.find(m => m.id_municipio === detallesGenerales.direccion_id_municipio);
        if (mun) {
          direccion_id_provincia = mun.id_provincia;
          const prov = PROVINCIAS.find(p => p.id_provincia === mun.id_provincia);
          if (prov) {
            direccion_id_pais = prov.id_pais;
          }
        }
      }

      setFormData((prevFormData) => ({
        ...prevFormData,
        //generales
        nombre: detallesGenerales.nombre || '',
        apellido:detallesGenerales.apellido || '',
        razon_social:detallesGenerales.razon_social || '',
        correo:detallesGenerales.correo || '',
        rnc:detallesGenerales.rnc || '',
        cedula:detallesGenerales.cedula || '',
        pasaporte: detallesGenerales.pasaporte || '',
        telefono: detallesGenerales.telefono || '',
        celular: detallesGenerales.celular || '',
        whatsapp: detallesGenerales.whatsapp || '',
        fecha_nacimiento:formatearFechaInput(detallesGenerales.fecha_nacimiento),
        comentario:detallesGenerales.comentario || '',
        id_sexo:detallesGenerales.id_sexo || null,
        id_pais:detallesGenerales.id_pais || null,

        // Dirección fija
        direccion_id_tipo_direccion: detallesGenerales.direccion_id_tipo_direccion || '',
        direccion_id_pais: direccion_id_pais,
        direccion_id_provincia: direccion_id_provincia,
        direccion_id_municipio: detallesGenerales.direccion_id_municipio || '',
        direccion_linea_uno: detallesGenerales.direccion_linea_uno || '',
        direccion_linea_dos: detallesGenerales.direccion_linea_dos || '',
        direccion_comentario: detallesGenerales.direccion_comentario || '',

        // Contacto fijo
        contacto_nombre: detallesGenerales.contacto_nombre || '',
        contacto_telefono: detallesGenerales.contacto_telefono || '',
        contacto_correo: detallesGenerales.contacto_correo || '',

        // Cuentas bancarias (3 slots fijos)
        cuenta_banco_1_id_banco: cuentas_banco[0]?.id_banco || '',
        cuenta_banco_1_id_tipo_cuenta: cuentas_banco[0]?.id_tipo_cuenta_banco || '',
        cuenta_banco_1_numero_cuenta: cuentas_banco[0]?.numero_cuenta || '',
        cuenta_banco_1_id_cuenta_banco_entidad: cuentas_banco[0]?.id_cuenta_banco_entidad || '',
        cuenta_banco_2_id_banco: cuentas_banco[1]?.id_banco || '',
        cuenta_banco_2_id_tipo_cuenta: cuentas_banco[1]?.id_tipo_cuenta_banco || '',
        cuenta_banco_2_numero_cuenta: cuentas_banco[1]?.numero_cuenta || '',
        cuenta_banco_2_id_cuenta_banco_entidad: cuentas_banco[1]?.id_cuenta_banco_entidad || '',
        cuenta_banco_3_id_banco: cuentas_banco[2]?.id_banco || '',
        cuenta_banco_3_id_tipo_cuenta: cuentas_banco[2]?.id_tipo_cuenta_banco || '',
        cuenta_banco_3_numero_cuenta: cuentas_banco[2]?.numero_cuenta || '',
        cuenta_banco_3_id_cuenta_banco_entidad: cuentas_banco[2]?.id_cuenta_banco_entidad || '',
      }));


      if (detallesCliente) {
        // Actualizar nombres de cuentas solo si existen
        const nuevosNombresCuentas = {};
        if (detallesCliente.nombre_cuenta_contable_debito) {
          nuevosNombresCuentas.id_cuenta_contable_debito_cliente = detallesCliente.nombre_cuenta_contable_debito;
        }
        if (detallesCliente.nombre_cuenta_contable_credito) {
          nuevosNombresCuentas.id_cuenta_contable_credito_cliente = detallesCliente.nombre_cuenta_contable_credito;
        }

        if (Object.keys(nuevosNombresCuentas).length > 0) {
          setNombresCuentas((prevFormData) => ({
            ...prevFormData,
            ...nuevosNombresCuentas
          }));
        }

        // Actualizar formData con los detalles del cliente
        setFormData((prevFormData) => ({
          ...prevFormData,
          //Detalles cliente
          descuento: detallesCliente.descuento || 0,
          limite_credito_cliente: detallesCliente.limite_credito || 0,
          limite_dias_credito: detallesCliente.limite_dias_credito || 0,
          tipo_cliente: detallesCliente.tipo_cliente || '',
          id_tipo_comprobante_fiscal_cliente: detallesCliente.id_tipo_comprobante_fiscal || null,
          id_lista_precio: detallesCliente.id_lista_precio || null,
          id_cuenta_contable_debito_cliente: detallesCliente.id_cuenta_contable_debito || null,
          id_cuenta_contable_credito_cliente: detallesCliente.id_cuenta_contable_credito || null,
        }));
      }

 
      if (detallesProveedor) {
        // Actualizar nombres de cuentas solo si existen
        const nuevosNombresCuentas = {};
        if (detallesProveedor.nombre_cuenta_contable_debito) {
          nuevosNombresCuentas.id_cuenta_contable_debito_proveedor = detallesProveedor.nombre_cuenta_contable_debito;
        }
        if (detallesProveedor.nombre_cuenta_contable_credito) {
          nuevosNombresCuentas.id_cuenta_contable_credito_proveedor = detallesProveedor.nombre_cuenta_contable_credito;
        }

        if (Object.keys(nuevosNombresCuentas).length > 0) {
          setNombresCuentas((prevFormData) => ({
            ...prevFormData,
            ...nuevosNombresCuentas
          }));
        }

        // Actualizar formData con los detalles del proveedor
        setFormData((prevFormData) => ({
          ...prevFormData,
          //Detalles proveedor
          id_cuenta_contable_debito_proveedor: detallesProveedor.id_cuenta_contable_debito || null,
          id_cuenta_contable_credito_proveedor: detallesProveedor.id_cuenta_contable_credito || null,
          limite_credito_proveedor: detallesProveedor.limite_credito || 0,
          es_informal: detallesProveedor.es_informal
        }));
      }

      if (detallesEmpleado) {
        // Actualizar nombres de cuentas solo si existen
        const nuevosNombresCuentas = {};
        if (detallesEmpleado.nombre_cuenta_contable_debito) {
          nuevosNombresCuentas.id_cuenta_contable_debito_empleado = detallesEmpleado.nombre_cuenta_contable_debito;
        }
        if (detallesEmpleado.nombre_cuenta_contable_credito) {
          nuevosNombresCuentas.id_cuenta_contable_credito_empleado = detallesEmpleado.nombre_cuenta_contable_credito;
        }

        if (Object.keys(nuevosNombresCuentas).length > 0) {
          setNombresCuentas((prevFormData) => ({
            ...prevFormData,
            ...nuevosNombresCuentas
          }));
        }

        // Actualizar formData con los detalles del empleado
        setFormData((prevFormData) => ({
          ...prevFormData,
          //Detalles empleado
          id_puesto: detallesEmpleado.id_puesto || null,
          fecha_contratacion: formatearFechaInput(detallesEmpleado.fecha_contratacion),
          fecha_salida: formatearFechaInput(detallesEmpleado.fecha_salida),
          fecha_vencimiento_licencia_conducir: formatearFechaInput(detallesEmpleado.fecha_vencimiento_licencia_conducir),
          id_cuenta_contable_debito_empleado: detallesEmpleado.id_cuenta_contable_debito || null,
          id_cuenta_contable_credito_empleado: detallesEmpleado.id_cuenta_contable_credito || null,
          id_sucursal: detallesEmpleado.id_sucursal || null,
        }));
      }
      if (detallesSueldo) {
        setFormData((prevFormData) => ({
          ...prevFormData,
            //Detalles sueldo

            sueldo_mensual:detallesSueldo.sueldo_mensual || 0,
            sueldo_x_hora:detallesSueldo.sueldo_x_hora || 0,
            incentivo_mensual:detallesSueldo.incentivo_mensual || 0,
            horas_diarias:detallesSueldo.horas_diarias || 0,
            aporte_extra:detallesSueldo.aporte_extra || 0,
            porcentaje_comision_x_venta:detallesSueldo.porcentaje_comision_x_venta || 0,
            porcentaje_comision_beneficio:detallesSueldo.porcentaje_comision_beneficio || 0,
            isr:detallesSueldo.isr || 0,
            afp:detallesSueldo.afp,
            sfs:detallesSueldo.sfs

  
        }));
      }
      

      
      setMostrarModalCliente(false);

      
    } catch (error) {
      console.log('error: ' + error)
    }
  }

  const [tabsActivos, setTabsActivos] = useState({
    general: true,
    cliente: false,
    proveedor: false,
    empleado: false,
  //  anexo: false,
  });


  const handleSeleccionCuenta = (cuenta) => {
    const campoId = campoCuentaActivo; 
    // console.log(campoId);  // Verificar que campoId esté correcto
    // console.log(cuenta);   // Verificar que cuenta esté correcto (es un array como [id, nombre])
  
    // Actualizar formData con el valor correcto de la cuenta
    setFormData((prev) => ({
      ...prev,
      [campoId]: cuenta[0],  // Asigna el ID de la cuenta
    }));
  
    // Actualizar nombresCuentas con el nombre de la cuenta
    setNombresCuentas((prev) => {
      const nuevo = { ...prev, [campoId]: cuenta[1] }; // Asigna el nombre de la cuenta
      return nuevo;
    });
  
    setCuentaSeleccionada(cuenta); // Guarda la cuenta seleccionada
    setMostrarModalCuenta(false);  // Cierra el modal
  };

  const obtenerTipoEntidad = (tab) => {
    switch (tab) {
      case "cliente":
        return 1; // Cliente = 1
      case "proveedor":
        return 2; // Proveedor = 2
      case "empleado":
        return 3; // Empleado = 3
      default:
        return null;
    }
  };
   

  const abrirModalCuenta = (campoId) => {
    setCampoCuentaActivo(campoId); // Guarda el campo activo para el que se abrirá el modal
    setMostrarModalCuenta(true);
  };

  const [tabSeleccionado, setTabSeleccionado] = useState("general");
  
  // Validación en tiempo real para RNC
  const validarRNCTiempoReal = (valor) => {
    if (!valor || valor.trim() === '') {
      setValidacionRNC({ valido: true, mensaje: '' });
      return;
    }
    
    const rncLimpio = valor.replace(/\D/g, '');
    if (rncLimpio.length < 9) {
      setValidacionRNC({ 
        valido: false, 
        mensaje: `RNC: ${rncLimpio.length}/9 dígitos` 
      });
    } else if (rncLimpio.length === 9) {
      setValidacionRNC({ 
        valido: true, 
        mensaje: '✓ RNC empresarial válido' 
      });
    } else if (rncLimpio.length === 10) {
      setValidacionRNC({ 
        valido: false, 
        mensaje: 'Debe ser 9 o 11 dígitos' 
      });
    } else if (rncLimpio.length < 11) {
      setValidacionRNC({ 
        valido: false, 
        mensaje: `Cédula: ${rncLimpio.length}/11 dígitos` 
      });
    } else if (rncLimpio.length === 11) {
      setValidacionRNC({ 
        valido: true, 
        mensaje: '✓ Cédula como RNC válida' 
      });
    } else {
      setValidacionRNC({ 
        valido: false, 
        mensaje: `Sobran ${rncLimpio.length - 11} dígitos` 
      });
    }
  };

  // Validación en tiempo real para Cédula
  const validarCedulaTiempoReal = (valor) => {
    if (!valor || valor.trim() === '') {
      setValidacionCedula({ valido: true, mensaje: '' });
      return;
    }
    
    const cedulaLimpia = valor.replace(/\D/g, '');
    if (cedulaLimpia.length < 11) {
      setValidacionCedula({ 
        valido: false, 
        mensaje: `Faltan ${11 - cedulaLimpia.length} dígitos` 
      });
    } else if (cedulaLimpia.length === 11) {
      setValidacionCedula({ 
        valido: true, 
        mensaje: '✓ Cédula válida' 
      });
    } else {
      setValidacionCedula({ 
        valido: false, 
        mensaje: `Sobran ${cedulaLimpia.length - 11} dígitos` 
      });
    }
  };

  const handleChange = (e) => {
    const { id, value } = e.target;

    // Convertir strings "true"/"false" a booleanos reales
    let valorFinal = value;
    if (value === "true") valorFinal = true;
    else if (value === "false") valorFinal = false;

    setFormData(prev => {
      const updated = { ...prev, [id]: valorFinal };
      // Cascada geográfica: limpiar dependientes al cambiar padre
      if (id === 'direccion_id_pais') {
        updated.direccion_id_provincia = '';
        updated.direccion_id_municipio = '';
      }
      if (id === 'direccion_id_provincia') {
        updated.direccion_id_municipio = '';
      }
      return updated;
    });

    // Validación en tiempo real para RNC y Cédula
    if (id === 'rnc') validarRNCTiempoReal(value);
    if (id === 'cedula') validarCedulaTiempoReal(value);
  };

  const handleChangeBusquedaRNC = (value) => {
    handleChange({
      target: {
        id: 'rnc',
        value
      }
    });
  };

  const handleSeleccionRNCDesdeDGII = (contribuyente) => {
    const razonSocial = (contribuyente?.razon_social || '').trim();
    const rnc = contribuyente?.rnc || '';

    setFormData((prev) => ({
      ...prev,
      rnc,
      razon_social: razonSocial || prev.razon_social,
      nombre: razonSocial || prev.nombre
    }));
    validarRNCTiempoReal(rnc);
  };

  const RegistrarEntidad = async (e) => {
    e.preventDefault();
    if (guardandoEntidad) return;

    if (!editable) {
      toast.error('Solo se pueden guardar cambios en modo edición o creación')
      return;
    }
    // const payload = ObtenerPayload(formData);
    // console.log(payload)
    // return
    ////////INICIO VALIDACIONES DE CAMPOS ============================================----------
    // console.log(formData);
   // return
    const errores = [
      { cond: !(formData.nombre || '').trim(), msg: 'El campo nombre es obligatorio' },
      { cond: !!formData.razon_social && !formData.razon_social.trim(), msg: 'La razón social no puede contener solo espacios en blanco' },
      { cond: formData.tipos_entidad.length === 0, msg: 'Seleccione al menos un tipo de entidad' },
      
      // Validaciones de formato con las funciones creadas en el archivo ValidacionesCampos.js
      { cond: !esEmailValido(formData.correo), msg: 'El formato del correo electrónico es inválido (Ej: ejemplo@ejemplo.com)' },
      { cond: !esRNCValido(formData.rnc), msg: 'El RNC debe tener 9 dígitos (empresas) o 11 dígitos (cédula como RNC)' },
      { cond: !esCedulaValida(formData.cedula), msg: 'La cédula debe tener exactamente 11 dígitos' },
      { cond: !esPasaporteValido(formData.pasaporte), msg: 'Formato de pasaporte inválido (6-14 caracteres alfanuméricos)' },
      { cond: !esTelefonoValido(formData.telefono), msg: 'Formato de teléfono inválido. Debe tener 10 dígitos' },
      { cond: !esTelefonoValido(formData.celular), msg: 'Formato de celular inválido' },
      { cond: !esTelefonoValido(formData.whatsapp), msg: 'Formato de WhatsApp inválido' },
      
      // Validaciones de fechas
      { cond: !noEsFechaFutura(formData.fecha_nacimiento), msg: 'La fecha de nacimiento no puede ser futura' },
    ];


    if (formData.tipos_entidad.includes(1)) { // 1 es cliente, estas son las validaciones para cliente.
      errores.push(
        { cond: !esPorcentajeValido(formData.descuento), msg: 'El descuento debe estar entre 0 y 100' },
        { cond: formData.limite_credito_cliente < 0, msg: 'El límite de crédito no puede ser negativo' },
        { cond: formData.limite_dias_credito < 0, msg: 'El límite de días de crédito no puede ser negativo' },
        { cond: !formData.tipo_cliente, msg: 'El tipo de cliente es obligatorio para clientes' },
        { cond: !formData.id_tipo_comprobante_fiscal_cliente, msg: 'El tipo de comprobante fiscal es obligatorio para clientes' },
        // ---------------------------------------------VALIDACIONES DE CUENTAS CONTABLES PARA CLIENTE ---------------------------------
       //{ cond: !formData.id_cuenta_contable_credito_cliente || formData.id_cuenta_contable_credito_cliente < 1, msg: 'La cuenta contable crédito (cuentas por cobrar) es obligatoria para clientes' },
      // { cond: !formData.id_cuenta_contable_debito_cliente || formData.id_cuenta_contable_debito_cliente < 1, msg: 'La cuenta contable débito (Ingresos) es obligatoria para clientes' }
      );
    }

    if (formData.tipos_entidad.includes(2)) { // 2 es proveedor, estas son las validaciones para proveedor.
      errores.push(
        {cond: formData.es_informal !== true && formData.es_informal !== false, msg: 'La formalidad es obligatoria para proveedores' },
        
        // Validación de límite de crédito
        { cond: !esNumeroNoNegativo(formData.limite_credito_proveedor), msg: 'El límite de crédito del proveedor no puede ser negativo' }
      // ---------------------------------------------VALIDACIONES DE CUENTAS CONTABLES PARA PROVEEDOR ---------------------------------
      // { cond: !formData.id_cuenta_contable_credito_proveedor || formData.id_cuenta_contable_credito_proveedor < 1, msg: 'La cuenta contable crédito (Gastos) es obligatoria para proveedores' },
      // { cond: !formData.id_cuenta_contable_debito_proveedor || formData.id_cuenta_contable_debito_proveedor < 1, msg: 'La cuenta contable débito (CxP) es obligatoria para proveedores' }
      );
    }

    if (formData.tipos_entidad.includes(3)) { // 3 es empleado, estas son las validaciones para empleado.
      errores.push(
      // ---------------------------------------------VALIDACIONES DE CUENTAS CONTABLES PARA EMPLEADO ---------------------------------
       // { cond: !formData.id_cuenta_contable_credito_empleado || formData.id_cuenta_contable_credito_empleado < 1, msg: 'La cuenta contable crédito (Gastos) es obligatoria para empleados' },
       // { cond: !formData.id_cuenta_contable_debito_empleado || formData.id_cuenta_contable_debito_empleado < 1, msg: 'La cuenta contable débito (CxP) es obligatoria para empleados' },
        { cond: !formData.id_sucursal , msg: 'La sucursal es obligatoria para empleados' },
        {cond: formData.afp !== true && formData.afp !== false, msg: 'Indicar el valor de AFP es obligatorio para empleados' },
        {cond: formData.sfs !== true && formData.sfs !== false, msg: 'Indicar el valor de SFS es obligatorio para empleados' },
        
        // Validaciones de fechas de empleado
        { cond: !noEsFechaFutura(formData.fecha_contratacion), msg: 'La fecha de contratación no puede ser futura' },
        { cond: formData.fecha_salida && formData.fecha_contratacion && !esFechaPosterior(formData.fecha_contratacion, formData.fecha_salida), 
          msg: 'La fecha de salida debe ser posterior a la fecha de contratación' },
        
        // Validaciones de montos no negativos
        { cond: !esNumeroNoNegativo(formData.sueldo_mensual), msg: 'El sueldo mensual no puede ser negativo' },
        { cond: !esNumeroNoNegativo(formData.sueldo_x_hora), msg: 'El sueldo por hora no puede ser negativo' },
        { cond: !esNumeroNoNegativo(formData.incentivo_mensual), msg: 'El incentivo mensual no puede ser negativo' },
        { cond: !esNumeroNoNegativo(formData.horas_diarias), msg: 'Las horas diarias no pueden ser negativas' },
        { cond: !esNumeroNoNegativo(formData.aporte_extra), msg: 'El aporte extra no puede ser negativo' },
        { cond: !esPorcentajeValido(formData.porcentaje_comision_x_venta), msg: 'El porcentaje de comisión por venta debe estar entre 0 y 100' },
        { cond: !esPorcentajeValido(formData.porcentaje_comision_beneficio), msg: 'El porcentaje de comisión por beneficio debe estar entre 0 y 100' }
      );
    }

    for (let error of errores) {
      if (error.cond) {
        toast.error(error.msg);
        return;
      }
    }
    ////////FIN VALIDACIONES DE CAMPOS ============================================----------

    setGuardandoEntidad(true);
    try {
      let id_entidad_ = formData.id_entidad
      const payload = ObtenerPayload(formData);
      console.log(payload);
      if (modo ==='creacion') {
        const respuesta = await instanciaAxios.post('/entidad', payload);

        id_entidad_ = respuesta.data.id_entidad
        setFormData((prevFormData) => ({
          ...prevFormData,
          id_entidad: respuesta.data.id_entidad,
        }));
        toast.success('Entidad registrada con éxito');
      }
      if (modo ==='edicion') {
        await instanciaAxios.put('/entidad', payload);
        toast.success('Entidad editada con éxito');
        // Recargar la entidad para obtener los IDs de los nuevos registros (cuentas banco)
        const entidadActualizada = await ObtenerEntidadDetallada(id_entidad_);
        const detallesGenerales = entidadActualizada.detallesGenerales;
        const cuentasBancoActualizadas = detallesGenerales.cuentas_banco || [];

        setFormData((prevFormData) => ({
          ...prevFormData,
          cuenta_banco_1_id_cuenta_banco_entidad: cuentasBancoActualizadas[0]?.id_cuenta_banco_entidad || '',
          cuenta_banco_2_id_cuenta_banco_entidad: cuentasBancoActualizadas[1]?.id_cuenta_banco_entidad || '',
          cuenta_banco_3_id_cuenta_banco_entidad: cuentasBancoActualizadas[2]?.id_cuenta_banco_entidad || '',
        }));
      }

      setModo('ver')
    } catch (error) {
      if (esErrorPermiso(error)) return;
      console.error('Error al guardar entidad:', error);

      const errorCode = error.response?.data?.error_code;
      const errorMessage = error.response?.data?.mensaje;

      switch (errorCode) {
        case 'RNC_DUPLICADO':
          toast.error(errorMessage || 'El RNC ya está registrado para otra entidad', {
            autoClose: 6000,
            position: 'top-center'
          });
          break;
        case 'RNC_INVALIDO':
        case 'CEDULA_INVALIDA':
          toast.error(errorMessage);
          break;
        default:
          toast.error(errorMessage || 'Error al guardar entidad');
      }
    } finally {
      setGuardandoEntidad(false);
    }
  };

  const camposFiltrados = camposFormulario.filter(campo =>
    (campo.tab ?? "general") === tabSeleccionado
  );

  const camposPorSeccion = camposFiltrados.reduce((acc, campo) => {
    if (!acc[campo.seccion]) acc[campo.seccion] = [];
    acc[campo.seccion].push(campo);
    return acc;
  }, {});


  async function handleBotonBuscar() {
    try {
      setMostrarModalCliente(true)
      setModo('ver');
    } catch (error) {
      console.log(error);
    }
  }

  async function handleBotonEditar() {
    try {
      setMostrarModalCliente(true)
      setModo('edicion');
    } catch (error) {
      console.log(error);
    }
  }

  async function handleBotonCrear() {
    try {
     //funcion para limpiar datos
      setModo('creacion');
    } catch (error) {
      console.log(error);
    }
  }


  return (
    cargando ? (
      <LoadingSpinner />
    ) : (
      <div className="bg-gray-200 min-h-screen">
        <div className="flex justify-center py-2 md:py-10">
          <div className="bg-gray-100 bg-opacity-90 rounded-xl border border-gray-100 p-3 sm:p-6 lg:p-12 w-full max-w-7xl mx-0 md:mx-10 pb-28 md:pb-6 lg:pb-12">
            <form onSubmit={RegistrarEntidad} className="flex flex-col gap-5 md:gap-8">
              <div className="space-y-1">
                <h1 className="font-cascadia font-bold text-2xl">Entidad</h1>
                <p className="text-gray-500">Complete los datos para registrar una nueva entidad</p>
              </div>

              {/* CHECKBOXES PARA ACTIVAR O DESACTIVAR TABS */}
              <div className='space-y-3'>
                <h2 className="text-lg font-semibold ">Tipo de entidad</h2>
                <p className='text-gray-500'>Seleccione los tipos de entidades a registrar.</p>
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 mb-6">
                  {Object.keys(tabsActivos).map((tab) => (
                    tab !== "general" && tab !== "empleado" && (
                      <label key={tab} className={`cursor-pointer px-3 py-2 rounded-lg border text-sm font-medium
                  ${tabsActivos[tab]
                          ? 'bg-color-secundario text-white border-color-secundario'
                          : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-100'}
                `}>
                        <input
                          type="checkbox"
                          className="sr-only"
                          checked={tabsActivos[tab]}
                          onChange={(e) => {
                            setTabsActivos(prev => {
                              const newTabs = {
                                ...prev,
                                [tab]: e.target.checked // Cambiar el estado del tab
                              };

                              // Actualizar el estado de formData.tipos_entidad al cambiar el checkbox
                              setFormData(prevFormData => {
                                const tipoEntidad = obtenerTipoEntidad(tab); // Obtener el tipo de entidad correspondiente
                                let tiposEntidadesActualizados = [...prevFormData.tipos_entidad];

                                if (e.target.checked) {
                                  // Si el checkbox se marca, agregar el tipo de entidad al array
                                  if (!tiposEntidadesActualizados.includes(tipoEntidad)) {
                                    tiposEntidadesActualizados.push(tipoEntidad);
                                  }
                                } else {
                                  // Si el checkbox se desmarca, eliminar el tipo de entidad del array
                                  tiposEntidadesActualizados = tiposEntidadesActualizados.filter(tipo => tipo !== tipoEntidad);
                                }

                                return {
                                  ...prevFormData,
                                  tipos_entidad: tiposEntidadesActualizados // Actualizar el estado con el array de tipos de entidad
                                };
                              });
                              return newTabs;
                            });

                            // Cambiar el tab seleccionado si el checkbox se desmarca
                            if (!e.target.checked && tabSeleccionado === tab) {
                              setTabSeleccionado("general");
                            }
                          }}
                        />
                        {tab.charAt(0).toUpperCase() + tab.slice(1)} {/* Capitalizar el nombre del tab */}
                      </label>
                    )
                  ))}
                </div>
              </div>


              {/* TABS ACTIVOS */}
              <div className='space-y-3'>
                <h2 className="text-lg font-semibold ">Sección por tipo de entidad</h2>
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 mb-6">
                  {Object.entries(tabsActivos).map(
                    ([tab, activo]) =>
                      activo && (
                        <button
                          key={tab}
                          type="button"
                          onClick={() => setTabSeleccionado(tab)}
                          className={`px-4 py-2 rounded-xl font-semibold border transition-colors duration-200 ${tabSeleccionado === tab
                              ? 'bg-color-secundario text-white'
                              : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-200'
                            }`}
                        >
                          {tab.charAt(0).toUpperCase() + tab.slice(1)}
                        </button>
                      )
                  )}
                </div>
              </div>


              {Object.entries(camposPorSeccion).map(([titulo, campos]) => {
                // Si la sección es "Contabilidad" y visibleContabilidad es false, no renderizar
                if (titulo === "Contabilidad" && !visible) {
                  return null;
                }

                return (
                  <div key={titulo}>
                    <h2 className="text-lg font-semibold mb-4">{titulo}</h2>
                    <div className="grid gap-4 grid-cols-[repeat(auto-fit,_minmax(min(100%,_230px),_1fr))]">
                      {campos.map(campo => (
                        <div key={campo.id} className="flex flex-col">
                          <label htmlFor={campo.id} className="text-sm font-medium text-gray-700 mb-1.5 flex items-center gap-1">
                            {campo.label}
                            {campo.required && editable && <span className="text-red-500 font-bold">*</span>}
                          </label>
                          {campo.custom ? (
                            // Si el campo tiene HTML personalizado,
                            // se le pasa la función solo si no está en modo "ver"
                            campo.custom(
                              formData[campo.id],
                              editable ? () => abrirModalCuenta(campo.id) : () => {}

                            )
                          ) : (campo.tipo_componente ?? "input") === "input" ? (
                            campo.id === 'rnc' ? (
                              <InputBusquedaRNC
                                value={formData[campo.id]}
                                onChange={handleChangeBusquedaRNC}
                                onSeleccionar={handleSeleccionRNCDesdeDGII}
                                placeholder="Buscar por RNC en DGII"
                                disabled={!editable}
                              />
                            ) : (
                              <input
                                type={campo.type}
                                id={campo.id}
                                className={`w-full p-2.5 rounded-xl text-gray-700 border-2 outline-none transition-all ${
                                  campo.required && editable
                                    ? 'border-red-200 focus:border-red-500 focus:ring-2 focus:ring-red-100' 
                                    : 'border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100'
                                }`}
                                value={formData[campo.id]}
                                onChange={editable ? handleChange : undefined}
                                placeholder={campo.placeholder}
                                disabled={!editable}
                              />
                            )
                          ) : campo.tipo_componente === "textarea" ? (
                            <textarea
                              id={campo.id}
                              className={`w-full p-2.5 rounded-xl text-gray-700 border-2 outline-none transition-all ${
                                campo.required && editable
                                  ? 'border-red-200 focus:border-red-500 focus:ring-2 focus:ring-red-100' 
                                  : 'border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100'
                              }`}
                              value={formData[campo.id]}
                              onChange={editable ? handleChange : undefined}
                              placeholder={campo.placeholder}
                              rows={3}
                              disabled={!editable}
                            />
                          ) : campo.tipo_componente === "select" ? (
                            <select
                              id={campo.id}
                              className={`w-full p-2.5 rounded-xl text-gray-700 border-2 outline-none transition-all ${
                                campo.required && editable
                                  ? 'border-red-200 focus:border-red-500 focus:ring-2 focus:ring-red-100' 
                                  : 'border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100'
                              }`}
                              value={formData[campo.id]}
                              onChange={editable ? handleChange : undefined}
                              disabled={!editable}
                            >
                              <option value="">Seleccione una opción</option>
                              {campo.opciones.map((opcion, index) => (
                                <option key={index} value={opcion.value}>
                                  {opcion.label}
                                </option>
                              ))}
                            </select>
                          ) : null}
                          
                          {/* Mensajes de validación en tiempo real */}
                          {campo.id === 'rnc' && validacionRNC.mensaje && (
                            <span className={`text-xs mt-1 ${validacionRNC.valido ? 'text-green-600' : 'text-orange-600'}`}>
                              {validacionRNC.mensaje}
                            </span>
                          )}
                          {campo.id === 'cedula' && validacionCedula.mensaje && (
                            <span className={`text-xs mt-1 ${validacionCedula.valido ? 'text-green-600' : 'text-orange-600'}`}>
                              {validacionCedula.mensaje}
                            </span>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })}



<div className="hidden md:block">
<DockVerticalDerecha  
  handleBotonBuscar={() => handleBotonBuscar()}
  handleBotonCrear={() => handleBotonCrear()}
  handleBotonEditar={() => handleBotonEditar()}
  handleBotonGuardar={(e) => RegistrarEntidad(e)} // Corregí la nomenclatura
  guardando={guardandoEntidad}
/>
</div>

{/* Barra de acciones fija (móvil) */}
<div className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-gray-300 shadow-[0_-2px_8px_rgba(0,0,0,0.1)] px-2 pt-2 pb-[max(0.5rem,env(safe-area-inset-bottom))] grid grid-cols-4 gap-2">
  <button type="button" onClick={() => handleBotonBuscar()} className="flex flex-col items-center gap-0.5 py-2 rounded-xl text-xs text-gray-700 active:bg-gray-100">
    <FiSearch size={20} /> Buscar
  </button>
  <button type="button" onClick={() => handleBotonCrear()} className="flex flex-col items-center gap-0.5 py-2 rounded-xl text-xs text-gray-700 active:bg-gray-100">
    <FiPlus size={20} /> Nuevo
  </button>
  <button type="button" onClick={() => handleBotonEditar()} className="flex flex-col items-center gap-0.5 py-2 rounded-xl text-xs text-gray-700 active:bg-gray-100">
    <FiEdit size={20} /> Editar
  </button>
  <button
    type="button"
    onClick={(e) => RegistrarEntidad(e)}
    disabled={guardandoEntidad}
    className="flex flex-col items-center gap-0.5 py-2 rounded-xl text-xs bg-color-primario text-white disabled:opacity-50"
  >
    <FiSave size={20} className={guardandoEntidad ? 'animate-pulse' : ''} /> {guardandoEntidad ? 'Guardando' : 'Guardar'}
  </button>
</div>



</form>
          </div>
          <ModalSeleccionCuenta
            mostrar={mostrarModalCuenta}
            onClose={() => setMostrarModalCuenta(false)}
            handleSeleccionCuenta={handleSeleccionCuenta}
           // titulo="Seleccione la cuenta contable débito (CxC)"
            descripcion="Seleccione la cuenta para asignar"
          />
          
          <PlantillaModal
          mostrar={mostarModalCliente}
          onClose={() =>setMostrarModalCliente(false)}
          >
            <TablaEntidad setEntidadSeleccionada={handleSeleccionarEntidad}/>
          </PlantillaModal>
          
        </div>
      </div>
    )
  );
};

export default MantenimientoEntidad;
